import { Dispatch } from 'react';
import { createUserWords, updateUserWords } from '../../api/UserWords';
import { wordsResponse, IUserWord } from '../../types';
import { BookAction, bookActionTypes, UserWordsAction, userWordsActionTypes } from '../type';
import { getUserWords } from '../../api/fetchUserWords';

export const fetchUserWords = (
  userId: string,
  group: string,
  page: string,
  wordsPerPage = '20'
) => {
  return async (dispatch: Dispatch<BookAction>) => {
    try {
      getUserWords(userId, `{"$and":[{"group": ${group}, "page": ${page}}]}`).then((data) => {
        dispatch({
          type: bookActionTypes.FETCH_WORDS_USER_SUCCESS,
          payload: data as wordsResponse[],
        });
      });
    } catch (e) {
      console.log(e);
    }
  };
};

export function removeWordsDiff(): UserWordsAction {
  return { type: userWordsActionTypes.DIFFICULT_WORDS_REMOVE };
}

export const fetchAllDiffWords = (userId: string) => {
  return async (dispatch: Dispatch<UserWordsAction>) => {
    dispatch({ type: userWordsActionTypes.FETCH_DIFF_WORDS_USER });

    if (!userId) return;
    try {
      await getUserWords(userId, `{"$and":[{"userWord.optional.difficult":true}]}`, '3600').then(
        (data) => {
          if (data.length === 0) {
            dispatch({
              type: userWordsActionTypes.DIFFICULT_WORDS_EMPTY,
            });
          } else {
            dispatch({
              type: userWordsActionTypes.FETCH_DIFF_WORDS_USER_SUCCESS,
              payload: data,
            });
          }
        }
      );
    } catch (e) {}
  };
};
export const fetchCreateUserWord = (
  userId: string,
  wordId: string,
  userWord: IUserWord,
  group = '0',
  page = '0'
) => {
  return async (dispatch: Dispatch<BookAction>) => {
    try {
      await createUserWords(userId, wordId, userWord);
      dispatch({
        type: bookActionTypes.CREATE_USER_WORDS,
      });
      const response = await getUserWords(
        userId,
        `{"$and":[{"group": ${group}, "page": ${page}}]}`
      );
      dispatch({
        type: bookActionTypes.FETCH_WORDS_USER_SUCCESS,
        payload: response as wordsResponse[],
      });
    } catch (e) {
      console.log(e);
    }
  };
};

export const fetchUpdateUserWord = (
  userId: string,
  wordId: string,
  fetchDataBody: IUserWord,
  group = '0',
  page = '0'
) => {
  return async (dispatch: Dispatch<BookAction>) => {
    try {
      await updateUserWords(userId, wordId, fetchDataBody);
      dispatch({
        type: bookActionTypes.UPDATE_USER_WORDS,
      });
      const response = await getUserWords(
        userId,
        `{"$and":[{"group": ${group}, "page": ${page}}]}`
      );
      dispatch({
        type: bookActionTypes.FETCH_WORDS_USER_SUCCESS,
        payload: response as wordsResponse[],
      });
    } catch (e) {
      console.log(e);
    }
  };
};
